window['contracts#edit'] = function () {
  $('#contract_prepared').on('change', function (e) {
    $('.contract_notification_user_ids').fadeToggle(e.target.checked)
  })
}
